import { sanitizeUrl } from './sanitizer';
export function loadImagePromise(url) {
    return loadHtmlElement(new Image(), url);
}
export function loadHtmlElement(element, url) {
    url = url && sanitizeUrl(url);
    const resolver = new PromiseResolver();
    element.onload = () => {
        resolver.resolve(element);
    };
    element.onerror = (e) => {
        resolver.reject(e);
    };
    if (typeof url === 'string') {
        element.src = url;
    }
    return resolver;
}
export function eventListenerToPromise(target, eventName) {
    const resolver = new PromiseResolver();
    const options = { once: true };
    target.addEventListener(eventName, resolver.resolve, options);
    return resolver.promise;
}
export function eventToPromise(emitter, eventName) {
    const resolver = new PromiseResolver();
    emitter.on(eventName, resolver.resolve);
    return resolver.promise;
}
export class PromiseResolver {
    constructor() {
        this.promise = new Promise((res, rej) => {
            this.resolve = res;
            this.reject = rej;
        });
    }
}
export function requestAnimationFramePromise() {
    return new Promise(resolve => {
        requestAnimationFrame((time) => {
            resolve(time);
        });
    });
}
export function sleep(milliseconds = 0) {
    return new Promise(resolve => {
        setTimeout(resolve, milliseconds);
    });
}
/**
 * Skip a number of animation frames.
 * 1 means that you skip the first and resolves on the second frame
 * @param frameToSkip
 */
export async function skipAnimationFrames(frameToSkip = 1) {
    for (let i = 0; i < frameToSkip + 1; i++) {
        await requestAnimationFramePromise();
    }
}
